"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDnd = require("react-dnd");
var _Item = _interopRequireDefault(require("../Item"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Target = function Target(props) {
  var targetId = props.targetId,
    items = props.items,
    itemProps = props.itemProps,
    placeholder = props.placeholder,
    setPlaceholder = props.setPlaceholder,
    moveItem = props.moveItem,
    className = props.className,
    isDisabled = props.isDisabled;
  var _useDrop = (0, _reactDnd.useDrop)({
      accept: 'item',
      canDrop: function canDrop(item, monitor) {
        if (isDisabled) {
          return false;
        }
        return item.group !== 'user' || targetId !== 'source';
      },
      drop: function drop(item) {
        moveItem(item, placeholder.targetId, placeholder.indexAfter + 1);
      },
      collect: function collect(monitor) {
        return {
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop()
        };
      },
      hover: function hover(draggedItem, monitor) {
        if (placeholder.targetId !== targetId) {
          setPlaceholder({
            targetId: targetId,
            indexAfter: items.length - 1
          });
        }
      }
    }),
    _useDrop2 = _slicedToArray(_useDrop, 2),
    _useDrop2$ = _useDrop2[0],
    isOver = _useDrop2$.isOver,
    canDrop = _useDrop2$.canDrop,
    drop = _useDrop2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: drop,
    className: className,
    "data-source-block": true,
    style: targetId !== 'source' && isOver && canDrop ? {
      background: 'rgba(51, 122, 183, 0.1)'
    } : {}
  }, placeholder && placeholder.show && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].placeholder,
    style: {
      paddingTop: canDrop && placeholder.targetId === targetId && placeholder.indexAfter === -1 ? "calc(".concat(placeholder.height, "px + 0.5em)") : 0
    }
  }), items.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "".concat(item.type, "_").concat(item.id)
    }, /*#__PURE__*/_react["default"].createElement(_Item["default"], _extends({
      index: index,
      targetId: targetId,
      item: item,
      placeholder: placeholder,
      setPlaceholder: setPlaceholder
    }, itemProps)), placeholder && placeholder.show && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].placeholder,
      style: {
        paddingTop: canDrop && placeholder.targetId === targetId && placeholder.indexAfter === index ? "calc(".concat(placeholder.height, "px + 0.5em)") : 0
      }
    }));
  }));
};
Target.propTypes = {
  targetId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  items: _propTypes["default"].array,
  itemProps: _propTypes["default"].object,
  placeholder: _propTypes["default"].object,
  setPlaceholder: _propTypes["default"].func,
  moveItem: _propTypes["default"].func,
  className: _propTypes["default"].string,
  isDisabled: _propTypes["default"].bool
};
Target.defaultProps = {
  className: ''
};
var _default = exports["default"] = Target;